import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface NightingaleChartProps {
  data: Array<{ name: string; value: number }>;
  height?: number | string;
  loading?: boolean;
}

export function NightingaleChart({ data, height, loading }: NightingaleChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    series: [{
      type: 'pie',
      radius: ['20%', '70%'],
      center: ['50%', '50%'],
      roseType: 'area',
      itemStyle: { borderRadius: 4 },
      data,
      label: { show: true, formatter: '{b}: {d}%' },
    }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
